import React from 'react';
import { Container } from 'react-bootstrap';
import styles from './SettingsPanel.module.css';

const SettingsPanel = (props) => {
    return (
        <div className={styles.SettingsPanel + ' p-3'}>
            {props.children}
        </div>
    )
}

export default SettingsPanel;